{
    "NAME": "LogManagementListLanguage",
    "LogManagementList_Column_Name": "Logbestand",
    "LogManagementList_Column_ClassName": "Voor de les",
    "LogManagementList_Column_FileName": "Bestandsnaam",
    "LogManagementList_Column_FileSize": "Bestandsgrootte",
    "LogManagementList_Column_Status": "Status",
    "LogManagementList_Status_Running": "Rennen",
    "LogManagementList_Status_NotRunning": "Niet actief",
    "LogManagementList_Action_Start": "Begin",
    "LogManagementList_Action_Stop": "Stop",
    "LogManagementList_Action_Reset": "Reset",
    "LogManagementList_Action_Download": "Download",
    "LogManagementList_SearchPlaceholder": "[Logbestand]",
    "LogManagementList_Empty": "Er worden momenteel geen logberichten weergegeven, wat waarschijnlijk duidt op een kritiek probleem met de initialisatie van de applicatie of een interne component.",
    "LogManagementList_Confirm_ResetTitle": "Logbestanden resetten",
    "LogManagementList_Confirm_ResetBody": "Waarschuwing: Als u ervoor kiest om een ​​of meer items in het logbestand te resetten, worden de bijbehorende bestanden verwijderd. Dit is een onherstelbare handeling.",
    "LogManagementList_Confirm_StopTitle": "Stop met loggen",
    "LogManagementList_Confirm_StopBody": "Het tijdelijk stoppen van het genereren van loguitvoer naar de geselecteerde logbestanden moet alleen worden gedaan wanneer u de betreffende bestanden in speciale situaties wilt bevriezen.",
    "LogManagementList_Confirm_Generic": "Weet u zeker dat u wilt doorgaan en de geselecteerde actie wilt uitvoeren?"
}